module.exports = __webpack_public_path__ + "static/media/lumea.751339da.png";